<ul class="conversation-list">
  <shared-conversation-list-search-bar
    [filterInputController]="filterInput"
    [showArchivedController]="showArchived"
    class="search-bar" />
  @let errors = conversationErrors();
  @if (errors.length > 0) {
    <div class="error-wrapper">
      @for (error of errors; track error.id) {
        <orbit-message
          [message]="error.message ?? error.code | translate"
          [severity]="'error'"
          [addonButtonIcon]="refreshIcon"
          (onAddonButtonClick)="refreshConversations()" />
      }
    </div>
  }
  <rx-virtual-scroll-viewport
    autosize
    class="menu-user-items"
    #conversationList
    (viewRange)="rangeChanged($event)"
    [runwayItems]="1"
    [runwayItemsOpposite]="1">
    <shared-conversation-header
      *rxVirtualFor="
        let conversation of conversations();
        trackBy: trackByFn;
        renderCallback: viewsRendered$
      "
      [isActive]="isActive(conversation.id)"
      [conversation]="conversation"
      [conversationType]="conversationTypes() | findBy: 'id' : conversation.conversationTypeId"
      data-testid="conversation-list-item"
      [attr.data-conversation-id]="conversation.id"
      (click)="changeActiveState(conversation.id)" />
  </rx-virtual-scroll-viewport>
</ul>
